/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveBar } from '@nivo/bar';
import { ThemeContext } from '../../../../context/ThemeProvider';
import { BACKEND_API } from '../../../../global/environment';
import Loader from '../../../../components/loader';

function AllFundsNetValueChart() {
  const { t } = useTranslation();
  const { t: tFunds } = useTranslation('fundNames');
  const { theme } = useContext(ThemeContext);
  const [fundsData, setFundsData] = useState([]);
  const [totalNetValue, setTotalNetValue] = useState(0);
  // eslint-disable-next-line no-undef

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    const fundNamesUrl = `${BACKEND_API}fundsMeta/netValue/last`;
    // eslint-disable-next-line no-underscore-dangle
    let _totalNetValue = 0;
    fetch(fundNamesUrl, { signal })
      .then((results) => results.json())
      .then((jsonData) => {
        jsonData.forEach((fundData) => {
          _totalNetValue += fundData.data;
        });
        setFundsData(jsonData);
        setTotalNetValue(_totalNetValue);
      })
      .catch(() => {});
    return function cleanup() {
      abortController.abort();
    };
  }, []);

  function BarComponent(barProps) {
    // In @nivo/bar v0.87, dimensions are inside the bar object itself
    const { bar } = barProps;

    if (!bar || !bar.data) {
      return null;
    }

    // The bar object contains: x, y, width, height, color, borderColor
    const { x, y, width, height, color, borderColor } = bar;

    // The bar.data.data contains the original data object from our API
    const indexValue = bar.data.indexValue || bar.data.id;
    const value = bar.data.value || bar.data.data;

    if (!indexValue || value === undefined) {
      return null;
    }

    // Ensure width and height are valid numbers
    const barWidth = typeof width === 'number' && !isNaN(width) ? width : 0;
    const barHeight = typeof height === 'number' && !isNaN(height) ? height : 0;
    const barX = typeof x === 'number' && !isNaN(x) ? x : 0;
    const barY = typeof y === 'number' && !isNaN(y) ? y : 0;

    if (barWidth <= 0 || barHeight <= 0) {
      return null;
    }

    return (
      <g transform={`translate(${barX},${barY})`}>
        <rect width={barWidth} height={barHeight} fill={color} />
        <rect x={barWidth - 5} width={5} height={barHeight} fill={borderColor} fillOpacity={0.2} />
        <text
          x={barWidth + 10}
          y={barHeight / 2 - 8}
          textAnchor="start"
          dominantBaseline="central"
          fill="black"
          style={{
            fontWeight: 900,
            fontSize: 15,
          }}
        >
          {tFunds(indexValue)}
        </text>
        <text
          x={barWidth + 10}
          y={barHeight / 2 + 10}
          textAnchor="start"
          dominantBaseline="central"
          fill={theme === 'dark' ? '#f5f8fa' : '#000'}
          style={{
            fontWeight: 400,
            fontSize: 13,
          }}
        >
          {`${value.toLocaleString('en-US')} ${t('MKD')}`}
        </text>
      </g>
    );
  }

  if (!fundsData[0]) {
    return <Loader />;
  }

  return (
    <>
      <h4>
        {t('Net Value (All Funds)')}: {`${totalNetValue.toLocaleString('en-US')} ${t('MKD')}`}
      </h4>
      <div style={{ height: `${fundsData.length * 35 + 100}px` }}>
        <ResponsiveBar
          data={fundsData}
          indexBy="id"
          keys={['data']}
          margin={{ top: 5, right: 300, bottom: 50, left: 5 }}
          padding={0.25}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
          blendMode={theme === 'dark' ? 'normal' : 'multiply'}
          layout="horizontal"
          axisTop={null}
          barComponent={BarComponent}
          enableGridX
          enableGridY={false}
          axisRight={null}
          axisLeft={null}
          enablePoints={false}
          colors={[
            '#B3CFFF',
            '#B3CFFF',
            '#ACC7F9',
            '#ACC7F9',
            '#A5C0F4',
            '#A5C0F4',
            '#9EB9EE',
            '#9EB9EE',
            '#97B1E9',
            '#97B1E9',
            '#8FAAE4',
            '#8FAAE4',
            '#88A3DE',
            '#88A3DE',
            '#819CD9',
            '#819CD9',
            '#7A94D3',
            '#7A94D3',
            '#738DCE',
            '#738DCE',
            '#6C86C9',
            '#6C86C9',
            '#647FC3',
            '#647FC3',
          ]}
          borderColor="#000000"
          colorBy="index"
          useMesh
          axisBottom={{
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            // legend: 'Net Value (in MKD)',
            legendPosition: 'middle',
            legendOffset: 46,
            tickValues: 3,
            format: (values) => {
              return values.toLocaleString('en-US');
            },
          }}
        />
      </div>
    </>
  );
}

export default React.memo(AllFundsNetValueChart);
